module.exports = __webpack_public_path__ + "static/img/5.83f968e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/5.jpg
// module id = U965
// module chunks = 13